import { t as r } from "./try-to-string.js";
var t = TypeError,
  e = function e(_e, o) {
    if (!delete _e[o]) throw t("Cannot delete property " + r(o) + " of " + r(_e));
  };
export { e as d };